<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
    
            <div id="myProfileFormBox" class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Mein Profil</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="account">Anmeldename</label>
                                <input id="account" class="pure-u-10-24" type="text" v-model="name" readonly>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="email">E-Mail</label>
                                <input id="email" class="pure-u-10-24" type="email" v-model="email" readonly>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="language">Sprache</label>
                                <input id="language" class="pure-u-10-24" type="text" v-model="language" readonly>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="comment">Bemerkungen</label>
                                <textarea id="comment" class="pure-u-10-24 comment" v-model="comment" readonly>

                                </textarea>
                            </div>
                        </div>

                        <legend  id="profileRole">Aktive Rolle: {{ activeRole }}</legend>
                        <div class="pure-g">
                            <div id="moduleBox" class="pure-u-4-24">
                                <select id="moduleDropDown" v-model="selectedRole">
                                    <option v-for="role in  roles" :key="role.role + '@' + role.customer" :value="role">{{ role.role }}&#64;{{ role.customer }}</option>
                                </select>
                            </div>
                            
                            <div id="addModuleBox" class="pure-u-3-24">
                                <a v-on:click="setActiveRole">Setzen</a>
                            </div>
                        </div>

                        <Role-editor id="profileRoles" :accountRoles="roles" readonly/>
                    </fieldset>
                </form>

            </div>        
        </div> 
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import axios from "axios"
import router from '@/router.js'
import { getJwt, getCustomerId, getCustomerName, getRole, changeActiveRole } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import RoleEditor from '@/components/RoleEditor.vue'
import { getApiUrl } from '@/utils/api.js'


export default {
    name: 'myProfileView',
    data: function () {
        return {
            data: null,
            activeRole: null,
            selectedRole: null,
            name: null,
            email: null,
            comment: null,
            password: null,
            passwordCheck: null,
            language: 'de',
            roles: [],
            languages: [
                { value: 'de', text: 'German' },
                { value: 'en', text: 'English' }
            ]
        }
    },
    components: {
        MainMenu,
        RoleEditor
    },
    mounted: function() {
        
        this.loadData(this.$route.params.url)
        this.loadActiveRole()
    },
    methods: {

        loadData: function(url) {

            axios(
                { 
                    method: 'GET', 
                    'url': getApiUrl() + '/v0/myprofile',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    }
                })
                .then(
                    result => {

                        this.data = result.data
                        this.name = result.data.name
                        this.email = result.data.email
                        this.language = result.data.language
                        this.comment = result.data.comment
                        this.roles = result.data.roles
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
            )
        },

        loadActiveRole: function() {

            var customerName = getCustomerName()
            var role = getRole() 
            if (customerName === undefined) customerName = '';

            this.activeRole = role + '@' + customerName
        },

        setActiveRole: function() {

            if (this.selectedRole == null) return

            var self = this
            var customerName = this.selectedRole.customer
            var role = this.selectedRole.role 
            if (customerName === undefined) customerName = '';

            var roleString = role + '@' + customerName
            changeActiveRole(roleString, function() {
                self.loadActiveRole()
                self.updateUi()
            })
        },

        updateUi: function() {

            router.push({
                name: "homeView"
            })
        }
    }
}
</script>


<style>

#myProfileFormBox {
    margin-top: 55px;
}

#profileRoles {
    margin-top: 10px;    
}

#profileRole {
    margin-top: 10px;    
}
</style>